import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot,
  DefaultUrlSerializer
} from '@angular/router';
import { Injectable } from '@angular/core';
import { VexRouteData } from '@vex/interfaces/vex-route.interface';

@Injectable()
export class CustomReuseStrategy implements RouteReuseStrategy {
  private storedRoutes: { [key: string]: DetachedRouteHandle } = {};

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const reuse = route.data && (route.data as VexRouteData).reuse;
    return !!reuse; // Only detach routes with 'reuse' set to true
  }

  store(
    route: ActivatedRouteSnapshot,
    handle: DetachedRouteHandle | null
  ): void {
    if (handle) {
      this.storedRoutes[route.routeConfig?.path || ''] = handle;
      // Optional: Clear cache if it exceeds a certain limit
      const cacheLimit = 5; // Example limit
      const routeKeys = Object.keys(this.storedRoutes);
      if (routeKeys.length > cacheLimit) {
        const oldestKey = routeKeys[0];
        delete this.storedRoutes[oldestKey];
      }
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return (
      !!route.routeConfig && !!this.storedRoutes[route.routeConfig.path || '']
    );
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return route.routeConfig
      ? this.storedRoutes[route.routeConfig.path || '']
      : null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    if (future.data['forceReload']) {
      return false; // Force reload when this flag is set
    }
    return future.routeConfig === curr.routeConfig;
  }

  /**
   * Clears or refreshes data when navigating back to the '/displayreport/outstanding' route.
   */
  clearDataOnReturn(route: ActivatedRouteSnapshot): void {
    if (route.routeConfig?.path === 'displayreport/outstanding') {
      // Logic to clear or modify data for this specific route

      // Here, call the service responsible for managing data and reset or fetch new data
      this.clearOutstandingData(); // This method will clear/reset data in the component

      // Optionally, you can trigger a method in the component itself (if needed) to clear UI state
    }
  }

  /**
   * Service or logic to clear or reload outstanding data.
   */
  private clearOutstandingData() {
    // This method should call the service that holds your table data or trigger a data reload
    // For example, using a service like:
    // this.dataService.clearOutstandingData();
    // or resetting state in your component through service:
    // this.outstandingDataService.reloadData();

    // Example:
    // outstandingDataService.clearData(); // Reset any cached data

  }
}
